import componentList from '../../builder/helpers/componentListData.js';
const mediaComponents = componentList.filter((comp) => comp.hasMedia === true)
const mediaComponentsType = mediaComponents.map((comp) => comp.type)

export const checkComponent = (component, count) => {

    for (const property in component) {
        if (mediaComponentsType.includes(component[property].type)) {
            const findMedia = mediaComponents.find((a) => a.type === component[property].type)
            if (findMedia?.mediaInfo.isArray) {
                let arr = component[property][findMedia?.mediaInfo['path']]
                const arrKeyLength = arr.length;
                for (let i = 0; i < arrKeyLength; i++) {
                    if (arr[i].image.id) {
                        count.push(arr[i].image.id)

                    } else {
                        continue
                    }
                }
            }
            if (findMedia?.mediaInfo?.isArray === false) {
                if (component[property][findMedia?.mediaInfo['path']].id) {
                    count.push(component[property][findMedia?.mediaInfo['path']].id)
                }
            }

        }

    }
    // log({ count, lengthCount: count.length })
    return count
}

export const handleColumnPasteMedia = (column, components, count) => {

    const { bgImage } = column.style;
    if (bgImage.id) {
        count.push(bgImage.id)
    }

    // for (const data in column) {
    //     if (column[data]?.bgImage?.id) {
    //         count.push(column[data].bgImage.id)
    //     }
    // }

    if (Object.keys(components).length > 0) {
        checkComponent(components, count)
    }
}

export const getMediaIDsFromPage = (content) => {
    const { section, column, component } = content;


    let count = []
    const start = performance.now();
    for (const data in section.entries) {
        if (section.entries[data].style.bgImage.id) {
            count.push(section.entries[data].style.bgImage.id)
        }
    }

    for (const data in column) {
        if (column[data].style.bgImage?.id) {
            count.push(column[data].style.bgImage.id)
        }
    }

    if (component && Object.keys(component).length > 0) {
        checkComponent(component, count)
    }

    const end = performance.now();
    const elapsedMilliseconds = end - start;
    console.log(`Task took ${elapsedMilliseconds} milliseconds.`);
    return count
}



export const handleComponentPasteMedia = (component, count) => {

    if (mediaComponentsType.includes(component.type)) {
        const findMedia = mediaComponents.find((a) => a.type === component['type'])
        if (findMedia?.mediaInfo.isArray) {
            const arr = component[findMedia.mediaInfo['path']]
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].image.id) {
                    count.push(arr[i].image.id)
                } else {
                    continue
                }
            }
        }
        else {
            count.push(component[findMedia?.mediaInfo['path']].id)
        }
    }
}

